import React from 'react';
import { Logo } from '../../../components/Logo';
import ManelMascot from '../../../components/ManelMascot';

export const PortalFooter: React.FC = () => {
  return (
    <footer className="bg-brand-midnight text-white/40 border-t border-white/5 overflow-hidden">
      <div className="container mx-auto px-6 py-24 relative">
        {/* Manél Footer Decor - Increased opacity for better visibility */}
        <div className="absolute right-0 bottom-0 opacity-40 pointer-events-none transform translate-x-1/4 translate-y-1/4">
          <ManelMascot pose={6} width={400} />
        </div>

        <div className="grid md:grid-cols-4 gap-16 relative z-10">
          <div className="space-y-8">
            <div className="flex items-end gap-5">
              <Logo width={160} className="brightness-125" />
              <div className="mb-[-15px] hidden lg:block">
                <ManelMascot pose={1} width={100} className="drop-shadow-glow-gold" />
              </div>
            </div>
            <p className="text-sm leading-relaxed max-w-xs font-medium italic">
              "Olá! Eu sou o <span className="text-brand-gold font-black">Manél</span>. Minha missão é guiar você para as melhores pescarias do Brasil."
            </p>
          </div>
          
          <div>
            <h4 className="text-white font-black text-xs uppercase tracking-[0.3em] mb-8">Pescadores</h4>
            <ul className="space-y-4 text-xs font-black uppercase tracking-widest">
              <li><a href="/estados" className="hover:text-brand-gold transition-colors">Buscar Destinos</a></li>
              <li><a href="/guias" className="hover:text-brand-gold transition-colors">Encontrar Guias</a></li>
              <li><a href="/marketplace" className="hover:text-brand-gold transition-colors">Marketplace</a></li>
              <li><a href="/explorar" className="hover:text-brand-gold transition-colors">Comunidade</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-white font-black text-xs uppercase tracking-[0.3em] mb-8">Empresas</h4>
            <ul className="space-y-4 text-xs font-black uppercase tracking-widest">
              <li><a href="/cadastrar-empresa" className="hover:text-brand-gold transition-colors">Divulgar Negócio</a></li>
              <li><a href="/planos" className="hover:text-brand-gold transition-colors">Vantagens</a></li>
              <li><a href="/login" className="hover:text-brand-gold transition-colors">Entrar</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-white font-black text-xs uppercase tracking-[0.3em] mb-8">Nossa Pesca</h4>
            <ul className="space-y-4 text-xs font-black uppercase tracking-widest">
              <li><a href="/sobre" className="hover:text-brand-gold transition-colors">Nossa História</a></li>
              <li><a href="/contato" className="hover:text-brand-gold transition-colors">Suporte</a></li>
              <li><a href="/termos" className="hover:text-brand-gold transition-colors">Privacidade</a></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-white/5 mt-20 pt-10 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-[10px] font-black uppercase tracking-widest">&copy; {new Date().getFullYear()} Nossa Pesca.com • Todos os direitos reservados.</p>
          <div className="flex gap-8">
             <span className="text-[10px] font-black uppercase tracking-widest text-brand-gold">Feito por Pescadores para Pescadores</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
